module.exports = __webpack_public_path__ + "img/certif_01.fdbe62f2.jpg";